import React, { useState } from 'react';
import styles from './Templates.module.css';
import TabBar from '../../components/tab-bar/TabBar';
import DocumentsTemplates from './DocumentsTemplates';
import MessagesTemplates from './MessagesTemplates';
import AnamnesisTemplates from './AnamnesisTemplates';
import { Box } from '@mui/material';
import { DescriptionOutlined as DocumentIcon } from '@mui/icons-material';
import AreaTitle from '../../components/areaTitle/AreaTitle';

const Templates = () => {
    const areas = [
        { id: 0, label: "Documentos" },
        { id: 1, label: "Mensagens" },
        { id: 2, label: "Anamneses" }
    ];

    const [currentArea, setCurrentArea] = useState(areas[0].id);

    const handleAreaChange = (newValue) => {
        setCurrentArea(newValue);
    };

    const getArea = () => {
        switch (currentArea) {
            case 0:
                return <DocumentsTemplates />;
            case 1:
                return <MessagesTemplates />;
            case 2:
                return <AnamnesisTemplates />;
            default:
                return <div></div>;
        }
    };

    return (
        <div className='page-content'>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 1,
                px: 2,
                pt: 1
            }}>
                <AreaTitle
                    Title="Modelos"
                    Description="Gerencie os modelos de documentos, mensagens e anamneses de sua empresa"
                    Icon={<DocumentIcon />}
                />
            </Box>
            
            <div className={styles.containerTable}>
                <TabBar 
                    labels={areas.map(item => item.label)} 
                    value={currentArea} 
                    onChange={handleAreaChange}
                />
                <div className={styles.tabContent}>
                    {getArea()}
                </div>
            </div>
        </div>
    );
};

export default Templates;